import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { RequestExtensionDialogData } from '../dialogs-data/request-extension-dialog-data';
import { RequestExtensionDialogComponent } from '../dialogs/request-extension-dialog/request-extension-dialog.component';

@Injectable()
export class RequestExtensionDialogService {
    constructor(private dialog: MatDialog) { }
    matDialogRef: MatDialogRef<RequestExtensionDialogComponent>;

    open(requestExtensionDialogData: RequestExtensionDialogData) {
        const matDialogConfig = new MatDialogConfig();
        matDialogConfig.panelClass = 'myapp-dialog';
        matDialogConfig.width = '540px';
        matDialogConfig.data = requestExtensionDialogData;
        matDialogConfig.disableClose = false;
        matDialogConfig.hasBackdrop = true;
        this.matDialogRef = this.dialog.open(RequestExtensionDialogComponent, matDialogConfig);
    }

    confirmed(): Observable<any> {
        return this.matDialogRef.afterClosed().pipe(
            take(1),
            map(res => {
                return res;
            })
        );
    }
}
